import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ObjectTypeEnumText } from '../../models/ObjectTypeEnum'
import { assessmentsApi, messagesApi, submissionsApi } from '../../../../utils'
import { throwApiError } from "../../store/error-handling-actions";
import classes from './CommunicationTeacher.module.css';
import Chat from "../../UI/Chat";
import { useParams } from "react-router-dom";
import { cretaeMessageContent } from "../../functions/Message";

const CommunicationTeacher = ({ onlyView, data, positionStyle }) => {

    const { lang, texts } = useSelector(state => state.translate);
    const [newMessage, setNewMessage] = useState()
    const [communicationTeacher, setCommunicationTeacher] = useState([])
    const [submissionId, setSubmissionId] = useState();

    const { user } = useSelector(state => state.auth);
    const { id, lessonId } = useParams();
    const dispatch = useDispatch();

    async function getData() {
        if (submissionId) {
            const messagesRangeFilter = {
                refObjectId: submissionId,
                refObjectType: ObjectTypeEnumText.Submission,
            }
            messagesApi.messagesFilterRangePost({ messagesRangeFilter }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: texts.MessageContentMessagesFilterRange, error: error, statusCode: response?.statusCode, message: "messagesFilterRangePost " + error.message, level: 2, component: "CommunicationTeacher", line: 27 }))
                } else {
                    resdata.sort((a, b) => new Date(a.sentDate) - new Date(b.sentDate))
                    setCommunicationTeacher(resdata.map(m => {
                        m.contents = m.contents?.length > 0 && JSON.parse(m.contents[0].content);
                        return m;
                    }))
                    setToRead(resdata)
                }
            })
        }
    }

    useEffect(() => {
        if (data && data.id && data.studyGroupId) {
            const assessmentFilterFinal = {
                lessonId: data.id,
            }
            assessmentsApi.assessmentsFilterFinalPost({ assessmentFilterFinal }, async (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: error, error: error, statusCode: response?.statusCode, message: "assessmentsFilterFinalPost " + error.message, level: 1, component: "CommunicationStudent", line: 53 }))
                }
                else {
                    if (resdata.id) {
                        if (resdata.submissionId) {
                            setSubmissionId(resdata.submissionId);
                        }
                        else {
                            const submissionAddInput = {
                                assessmentId: resdata.id,
                                studyGroupId: data.studyGroupId,
                            }
                            submissionsApi.submissionsAddPost({ submissionAddInput }, (submissionsError, submissionsResdata, submissionsResponse) => {
                                if (!submissionsError) {
                                    setSubmissionId(submissionsResdata.submission.id);
                                }
                            })
                        }
                    }
                }
            })
        }
    }, [data])

    useEffect(() => {
        getData();
    }, [submissionId])

    function setToRead(messages) {
        if (messages.length > 0) {
            let messagesIds = []
            messages.forEach(m => {
                if (m.sourceObjectId !== user.id && !m.isRead) {
                    messagesIds.push(m.id)
                    m.isRead = true
                }
            });
            if (messagesIds.length > 0) {
                const messageSetReadRangeInput = {
                    messagesIds: messagesIds
                }
                messagesApi.messagesSetReadRangePost({ messageSetReadRangeInput }, (error, resdata, response) => {
                    if (error) {
                        dispatch(throwApiError({ userMessage: texts.MessageContentMessagesSetReadRange, error: error, statusCode: response?.statusCode, message: "messagesSetReadRangePost " + error.message, level: 1, component: "CommunicationTeacher", line: 58 }))
                    }
                })
            }
        }
    }

    function sendMessage() {
        setNewMessage("")
        if (newMessage) {
            let newMessageEnter = newMessage.replaceAll('\n', '\\\\n')
            let contentString = `{"${lang}": "{ \\"text\\": \\"${newMessageEnter}\\" }"}`
            let content = JSON.parse(contentString)
            const messageAddOrUpdateInput = {
                refObjectId: submissionId,
                refObjectType: ObjectTypeEnumText.Submission,
                contents: content
            }

            messagesApi.messagesAddPost({ messageAddOrUpdateInput }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: texts.MessagePostError, error: error, statusCode: response?.statusCode, message: "messagesAddPost " + error.message, level: 2, component: "CommunicationStudent", line: 86 }))
                }
                else {
                    getData()
                    const idOrLessonId = id || lessonId;
                    const textHe = `${texts.communicationStudentNewMesageHe}${user.firstName} ${user.lastName} ${newMessage.length > 14 ? newMessage + "..." : newMessage}`
                    const textAr = `${texts.communicationStudentNewMesageAr}${user.firstName} ${user.lastName} ${newMessage.length > 14 ? newMessage + "..." : newMessage}`
                    const textEn = `${texts.communicationStudentNewMesageEn}${user.firstName} ${user.lastName} ${newMessage.length > 14 ? newMessage + "..." : newMessage}`
                    const link = `${idOrLessonId}/lesson/${data?.id}`;
                    const content = cretaeMessageContent(textHe, textAr, textEn, link);
                    const data2 = {
                        refObjectId: idOrLessonId,
                        refObjectType: ObjectTypeEnumText.StudyGroup,
                        // targetObjectId: submissionDetails?.submittedByUserId, //change
                        targetObjectType: ObjectTypeEnumText.User,
                        contents: content
                    }
                    // const oldData = {
                    //     refObjectId: submissionId,
                    // refObjectType: ObjectTypeEnumText.Submission,
                    //     sentDate: new Date(),
                    //     expiredDate: null,
                    //     content: content

                    // }
                    messagesApi.messagesAddPost({ messageAddOrUpdateInput: data2 }, (error, resdata, response) => {
                        if (error) {
                            dispatch(throwApiError({ userMessage: texts.MessagePostError, error: error, statusCode: response?.statusCode, message: "messagesAddPost " + error.message, level: 1, component: "CommunicationStudent", line: 107 }))
                        }
                    })
                }
            })
        }
    }

    return (
        <div className={classes.CommunicationTeacherWrapper} style={{ position: positionStyle }}>
            {onlyView && <div className={classes.ScreenLockOnlyView}></div>}
            <div className={classes.Title}>{texts.communicationWithTeacher}</div>
            <Chat
                dropClass={classes.ChatFromTeacher}
                id={submissionId}
                sendMessage={sendMessage}
                communication={communicationTeacher}
                setNewMessage={setNewMessage}
                newMessage={newMessage} />
        </div >
    )
}
export default CommunicationTeacher;